import { Button } from "antd";
import type { ButtonProps } from "antd";
import { CSSProperties, forwardRef } from "react";

export type UIButtonProps = Omit<ButtonProps, "type" | "variant"> & {
  type?: "button" | "submit" | "reset";
  buttonType?: ButtonProps["type"];
  variant?: "text" | "outlined" | "contained";
  fullWidth?: boolean;
  sx?: Record<string, unknown>;
};

export const UIButton = forwardRef<any, UIButtonProps>(
  (
    {
      variant,
      type,
      buttonType,
      fullWidth,
      sx,
      style,
      ...props
    }: UIButtonProps,
    ref
  ) => {
    const resolvedType =
      buttonType ??
      (variant === "contained"
        ? "primary"
        : variant === "text"
        ? "text"
        : "default");

    const sxStyle = (sx ?? {}) as CSSProperties;

    return (
      <Button
        ref={ref}
        type={resolvedType}
        htmlType={type}
        style={{ ...(fullWidth ? { width: "100%" } : {}), ...sxStyle, ...style }}
        {...props}
      />
    );
  }
);

UIButton.displayName = "UIButton";
